<template>
  <!-- 案件詳細 -->
  <div id="HolterRequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td>
                <a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a>
                <span v-if="data.depo" class="depo"/>
              </td>
            </tr>
            <tr>
              <th>機種</th>
              <td>{{data.instrumentKind}}</td>
            </tr>
            <tr>
              <th>検査期間</th>
              <td>{{data.inspectionPeriod | desiredDeliveryTimeZoneFilter(inspectionPeriodList)}}</td>
            </tr>
            <tr>
              <th>解析オプション</th>
              <td>{{data.analysisOption | desiredDeliveryTimeZoneFilter(analysisOptionList)}}</td>
            </tr>
            <tr>
              <th>依頼元</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.client}}</td>
            </tr>
            <tr>
              <th>医療機関</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientName}}</td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>{{data.applicationDate}}</td>
            </tr>
            <tr>
              <th>出荷日</th>
              <td>{{data.shippingDate}}</td>
            </tr>
            <tr>
              <th>配送先</th>
              <td v-if="data.delivaryTarget == 'home'">患者宅に配達する</td>
              <td v-if="data.delivaryTarget == 'hospital'">医療機関に配達する</td>
            </tr>
            <tr v-if="data.delivaryTarget == 'hospital' && !atLaunchHidden.hiddenFlag">
              <th>リードワイヤーアダプター</th>
              <td v-if="data.leadWireAdapter">必要</td>
              <td v-else>不要</td>
            </tr>
            <tr>
              <th>WP300同梱の有無</th>
              <td v-if="data.hstRequestFlag">有</td>
              <td v-else>無</td>
            </tr>
            <tr>
              <th>配達希望時間帯</th>
              <td>{{data.desiredPickupTimeZone | desiredDeliveryTimeZoneFilter(desiredDeliveryTimeZoneList)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td><textarea v-model="data.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="reception">受付</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="100px">
        <holterRequestDetail v-bind:data="data.applicationDetails"/>
      </floatingModal>
    </div>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";

export default {
  name: "HolterRequestAcceptDetail", 
  props: ["detailData"],
  methods: {
    back: function () {
      this.$router.push({
        name: "HolterRequestAccept",
        params: { searchConditions: this.searchParams },
      });
    },
    reception: async function() {
      var excuteApi = this.setHolterRequestPOST;
      var successCallBack = this.setHolterRequestPOSTSuccess;
      var errorCallBack = this.setHolterRequestPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      return client.apis.internalHolter.setHolterRequestPOST({ 
        body:[obj]
      });
    },
    setHolterRequestPOSTSuccess: function(result) {
      this.showSuccess(result,this.back())
    },
    setHolterRequestPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    doSearch: function() {
      var excuteApi = this.getHolterRequestDetailPOST;
      var successCallBack = this.getHolterRequestDetailPOSTSuccess;
      var errorCallBack = this.getHolterRequestDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterRequestDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterRequestDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHolterRequestDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj;
    },
    getHolterRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
  },
  data() {
    let targetNumber = this.$route.params["receiptNumber"];
    let searchParams = this.$route.params["searchConditions"];
    let desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    let inspectionPeriodList = [];
    if(this.$route.params["holterJudgmentFlg"]) {
      inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriodJudgment, true);
    }else{
      inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    }
    desiredDeliveryTimeZoneList.unshift({})
    analysisOptionList.unshift({})
    inspectionPeriodList.unshift({})
    return {
      data:[],
      targetNumber,
      searchParams,
      desiredDeliveryTimeZoneList,
      analysisOptionList: analysisOptionList,
      inspectionPeriodList: inspectionPeriodList,
      atLaunchHidden: atLaunchHidden
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    desiredDeliveryTimeZoneFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: { 
    floatingModal:floatingModal,
    holterRequestDetail:HolterRequestDetail
  }
};
</script>
<style lang="scss" scoped>
.receptionistButton {
    width:100px;
}

table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    color: red;
    font-weight: bold; 
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterRequestAcceptDetail.vue